/* @flow */

import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import range from 'lodash/range';

type Props = {
  value: number,
  orderCount: number,
  onChange: (order: number) => void,
};

const getAvailableOrders = (orderCount: number) => {
  return range(1, orderCount + 1).map(o => ({
    text: o,
    value: o,
  }));
};

const OrderDropdown = ({ value, orderCount, onChange, ...other }: Props) => {
  const changeOrder = (_, { value: newValue }) => {
    const newOrder = newValue - 1;
    if (newOrder !== value) {
      onChange(newOrder);
    }
  };

  return (
    <Dropdown
      style={{ zIndex: 100 }}
      compact
      selection
      value={value + 1}
      options={getAvailableOrders(orderCount)}
      onChange={changeOrder}
      {...other}
    />
  );
};

export default OrderDropdown;



// WEBPACK FOOTER //
// ./src/shared/components/OrderDropdown.js